// @flow

/* eslint-env browser */

export const supportsSelector = (selector: string): boolean => {
  try {
    // Regular check - does not work in at least chromium 81
    // $FlowFixMe - flow does not know `CSS` object.
    if (CSS && CSS.supports(`selector(${selector})`)) {
      return true;
    }

    // uglier check

    document.querySelectorAll(selector);

    return true;
  } catch (e) {
    return false;
  }
};
